import { SortInput } from 'components/Table'
import { AbTestsSortBy } from './hooks/useGetAbTests/types'

export const DEFAULT_SORT: SortInput<AbTestsSortBy> = {
  by: 'updatedAt',
  direction: 'desc',
} as const

export const SORTABLE_COLUMNS: AbTestsSortBy[] = [
  'endedAt',
  'name',
  'startedAt',
  'updatedAt',
  'domainName',
]
